import { render, staticRenderFns } from "./custom-select-icon.vue?vue&type=template&id=2109798b&scoped=true"
import script from "./custom-select-icon.vue?vue&type=script&lang=js"
export * from "./custom-select-icon.vue?vue&type=script&lang=js"
import style0 from "./custom-select-icon.vue?vue&type=style&index=0&id=2109798b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2109798b",
  null
  
)

export default component.exports